import { useState } from "react";

interface FAQItem {
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    question: "风车动漫的动漫资源有多少？",
    answer:
      "风车动漫目前收录了超过5000部动漫作品，涵盖热血战斗、搞笑日常、奇幻冒险、悬疑推理、恋爱治愈、日常治愈等多种类型，覆盖从经典老番到最新热播的各个年代。我们的动漫库每天都在持续更新中。",
  },
  {
    question: "风车动漫是否需要注册才能观看？",
    answer:
      "不需要！风车动漫支持免注册在线观看，您可以直接浏览和观看所有动漫内容。当然，注册账号后可以享受更多个性化功能，如收藏追番、观看记录同步等。",
  },
  {
    question: "风车动漫支持哪些设备观看？",
    answer:
      "风车动漫全面支持PC端、平板和手机端观看。我们的网站采用响应式设计，无论在哪种设备上都能获得流畅的观看体验。推荐使用最新版本的Chrome、Edge或Safari浏览器。",
  },
  {
    question: "动漫更新频率是怎样的？",
    answer:
      "我们会在每个新番播出季第一时间更新最新剧集。热门连载动漫通常每周更新一到两集，同步日本播出进度。完结作品会一次性完整上线，方便您一口气追完整部动漫。",
  },
  {
    question: "视频画质怎么样？",
    answer:
      "风车动漫提供多种清晰度选择，包括标清、高清和超清画质。我们采用先进的视频编码技术，在保证画质的同时优化加载速度，让您享受流畅清晰的观影体验。",
  },
  {
    question: "如何反馈问题或提出建议？",
    answer:
      "您可以通过网站底部的联系方式或关于我们页面中的反馈渠道与我们取得联系。我们非常重视每一位用户的意见，会在第一时间处理您的反馈。也可以发送邮件至 contact@fengchedongman.com。",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-4xl mx-auto w-full">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-100">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            关于风车动漫的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-800/40 border border-background-700/40 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-200 pr-4">
                  {item.question}
                </span>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-500 transition-transform duration-200">
                  <i
                    className={`ri-arrow-down-s-line text-base ${
                      openIndex === index ? "rotate-180" : ""
                    }`}
                  ></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4 animate-fade-in">
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqItems.map((item) => ({
              "@type": "Question",
              name: item.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: item.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}